import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';
import EmailInput from '../../Global/Forms/EmailInput';
import Button from '../../Global/Buttons/Button';
import Form from "../../Global/Forms/Form";

const ChangeEmailForm = ({
  currentEmail,
  submitting,
  // Formik props
  values,
  errors,
  touched,
  handleChange,
}) => {
  const hasFormChanged = () => {
    if (currentEmail === values.email) {
      return false;
    }
    return true;
  };

  return (
    <Form className="m-b-5">
      <h3 className="like-h3 m-b-3">Email address</h3>

      <fieldset className="m-b-5">
        <div className="row">
          <div className="col-sm-6">
            <EmailInput
              name="email"
              label="Email address"
              maxLength={200}
              value={values.email}
              onChange={handleChange}
              error={errors.email}
              touched={touched.email}
              required
            />
          </div>

          <div className="col-sm-6">
            <EmailInput
              name="confirmEmail"
              label="Confirm email address"
              maxLength={200}
              value={values.confirmEmail}
              onChange={handleChange}
              error={errors.confirmEmail}
              touched={touched.confirmEmail}
              required
            />
          </div>
        </div>

        <div className="text-right form-group">
          <Button type="submit" loading={submitting} disabled={hasFormChanged() === false}>Change email</Button>
        </div>
      </fieldset>
    </Form>
  );
};

ChangeEmailForm.propTypes = {
  currentEmail: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  // Formik
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

const FormikChangeEmailForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues({ currentEmail }) {
    return {
      email: currentEmail || ``,
      confirmEmail: currentEmail || ``,
    };
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .label(`Email address`)
      .email()
      .matches(/^[A-Za-z0-9.+_-]+@[A-Za-z0-9._-]+\.[a-zA-Z]*$/, `Must not contain international characters`)
      .required(),
    confirmEmail: Yup.string()
      .label(`Confirm email address`)
      .oneOf([Yup.ref(`email`)], `Must match your email address`)
      .required(),
  }),
  handleSubmit(values, bag) {
    bag.props.onSubmit(values);
  },
})(ChangeEmailForm);

export default FormikChangeEmailForm;



// WEBPACK FOOTER //
// ./library/app/components/Account/AccountDetails/ChangeEmailForm.js